import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const KEY = 'nextxus_admin_jwt';

export const getAdminToken = () => localStorage.getItem(KEY) || '';
export const setAdminToken = (t) => localStorage.setItem(KEY, t);
export const clearAdminToken = () => localStorage.removeItem(KEY);
export const isAdminAuthed = () => !!getAdminToken();

export const adminHeaders = () => {
  const t = getAdminToken();
  return t ? { Authorization: `Bearer ${t}` } : {};
};

export const adminLogin = async (password) => {
  const res = await axios.post(`${API}/admin/login`, { password });
  if (res.data?.token) setAdminToken(res.data.token);
  return res.data;
};
